module.exports = __webpack_public_path__ + "img/contact_02.5a1188eb.png";